module.exports = __webpack_public_path__ + "static/media/comp1.c9b62844.png";